import { ConcentrationCalculator } from './ConcentrationCalculator';

export class OneCompartmentConcentrationCalculator extends ConcentrationCalculator {
  private readonly kel: number;
  private readonly vd: number;

  constructor(kel: number, vd: number) {
    super();
    this.kel = kel;
    this.vd = vd;
  }

  concentrationDuringInfusion(
    startConcentration: number,
    dosePerHr: number,
    infusionInHrs: number,
    _timeDelta: number,
  ): number {
    const result =
      startConcentration * Math.exp(-this.kel * infusionInHrs) +
      (dosePerHr / (this.vd * this.kel)) * (1 - Math.exp(-this.kel * infusionInHrs));
    // console.log(`concentrationDuringInfusion(startConcentration=${startConcentration}, dosePerHr=${dosePerHr}, infusionInHrs=${infusionInHrs}) = ${result}, timeDelta=${timeDelta}`);
    return result;
  }

  concentrationDuringDecay(
    startConcentration: number,
    decayInHrs: number,
    _timeDelta: number,
  ): number {
    const result = startConcentration * Math.exp(-this.kel * decayInHrs);
    // console.log(`concentrationDuringDecay(startConcentration=${startConcentration}, decayInHrs=${decayInHrs}) = ${result}, timeDelta=${timeDelta}`);
    return result;
  }

  calculatePeak(intervalInHrs: number, infusionInHrs: number, dosePerHr: number): number {
    return (
      ((dosePerHr / (this.vd * this.kel)) * (1 - Math.exp(-this.kel * infusionInHrs))) /
      (1 - Math.exp(-this.kel * intervalInHrs))
    );
  }

  calculateTrough(intervalInHrs: number, infusionInHrs: number, dosePerHr: number): number {
    const peak = this.calculatePeak(intervalInHrs, infusionInHrs, dosePerHr);
    return this.concentrationDuringDecay(peak, intervalInHrs - infusionInHrs, -1);
  }

  calculateTroughFromPeak(intervalInHrs: number, infusionInHrs: number, peak: number): number {
    return this.concentrationDuringDecay(peak, intervalInHrs - infusionInHrs, -1);
  }

  calculatTmicFromPeak(
    peak: number,
    intervalInHrs: number,
    infusionInHrs: number,
    mic: number | null | undefined,
  ): number | null {
    if (mic) {
      let t_inf_mic = 0;
      if (infusionInHrs > 0) {
        const c = Math.sqrt(infusionInHrs * infusionInHrs + peak * peak);
        const sinA = (infusionInHrs * Math.sin(90)) / c;
        const tmic = (sinA * sinA * mic) / (infusionInHrs * peak);
        t_inf_mic = infusionInHrs - tmic;
      }
      // Decay from Peak to MIC + infusion from MIC
      return Math.log(peak / mic) / this.kel + t_inf_mic;
    }
    return null;
  }

  calculateSteadyState(dose: number, intervalInHrs: number, _infusionInHrs: number): number {
    const cl: number = this.kel * this.vd;
    return dose / (cl * intervalInHrs);
  }
}
